/* eslint-disable import/no-unresolved */
import React from 'react';

import TeamMembers from './aboutUsPartials/TeamMembers';
import TeamHeader from './aboutUsPartials/TeamHeader';

const AboutUsTeam = () => {
  return (
    <div className="team-beam">
      <div className="container">
        <div className="body">
          <TeamHeader />
          <h3>Meet our management team</h3>
          <TeamMembers />
        </div>
      </div>
    </div>
  );
};

export default AboutUsTeam;
